import { LitElement, html } from 'lit';
import styles from './styles';
/**
 * @slot - The element's content.
 *
 * @csspart base - The element's base container.
 */
export default class AmityekoTgLabelOne extends LitElement {
    render() {
        return html `<p part="base"><slot></slot></p>`;
    }
}
AmityekoTgLabelOne.styles = styles;
if (!customElements.get('amityeko-tg-label-one')) {
    customElements.define('amityeko-tg-label-one', AmityekoTgLabelOne);
}
//# sourceMappingURL=index.js.map